import { ApiClient } from "../../utils/api-client";


export const getUserRequests = async (page, pageSize, identification, status, orderBy, direction) => {
  try {
    const response = await ApiClient.get('/requests', {
      params: {
        page: page,
        pageSize: pageSize,
        identification: identification,
        requeststatus: status,
        orderBy: orderBy,
        orderDirection: direction
      }
    });

    const objectToReturn = {
      pagination: response.data.pagination || { totalItems: 0 },
      userGradeRequests: response.data.GradeRequests || []
    }
    return objectToReturn;
  } catch (e) {
    return await [];
  }
}

export const getUserRequestsById = async id => {
  try {
    const response = await ApiClient.get('/requests/' + id, {});

    return response.data;
  } catch (e) {
    return await {};
  }
}

export const getUserRequestCount = async () => {
  try {
    const response = await ApiClient.get('/scorecard', {});
    return response.data;
  } catch (e) {
    return await { requestGrades: 0, activeGrades: 0, expiredGrades: 0 }
  }

}
